import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'Xmas2022QuestsButtonLayout',
  width: 654,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: '800ee90b-4e36-41bf-a43b-f5eeb7eb6a71',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 0.8,
        y: 0.8
      },
      pivot: {
        x: 202,
        y: 54
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '406b1e2f-c826-4ee5-b128-d3261f1d8eea',
      type: 'NineSlicePlane',
      name: 'mission_tray_container',
      nameSpace: '',
      className: '',
      x: -283,
      y: 3,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 350,
      height: 105,
      leftWidth: 40,
      topHeight: 40,
      rightWidth: 40,
      bottomHeight: 40,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'UI_Christmas_mission_notification_panel',
      parent: '800ee90b-4e36-41bf-a43b-f5eeb7eb6a71',
      data: ''
    },
    {
      id: 'd7db3b5e-7487-49e1-8608-28bff942d916',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -27,
      y: -39,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'UI_Christmas_mission_button_frame',
      parent: '800ee90b-4e36-41bf-a43b-f5eeb7eb6a71',
      data: ''
    },
    {
      id: '794bfcca-e61f-4b3d-b86a-05558c8b14eb',
      type: 'Sprite',
      name: 'mission_button_base_active',
      nameSpace: '',
      className: '',
      x: 165,
      y: 40,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'UI_Christmas_mission_button',
      parent: '800ee90b-4e36-41bf-a43b-f5eeb7eb6a71',
      data: ''
    },
    {
      id: '7539a2e0-c62e-425c-87e2-13a6c99f1805',
      type: 'Sprite',
      name: 'mission_button_base_timer',
      nameSpace: '',
      className: '',
      x: 165,
      y: 40,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'UI_Christmas_mission_button2',
      parent: '800ee90b-4e36-41bf-a43b-f5eeb7eb6a71',
      data: ''
    },
    {
      id: '52caeeba-d355-408d-bcd8-829624648127',
      type: 'Sprite',
      name: 'mission_button_base_reward',
      nameSpace: '',
      className: '',
      x: 165,
      y: 40,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'UI_Christmas_mission_button2',
      parent: '800ee90b-4e36-41bf-a43b-f5eeb7eb6a71',
      data: ''
    },
    {
      id: '31adbf9e-5830-4b59-b53c-cb415d836ec6',
      type: 'Container',
      name: 'mission_progress_container',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '406b1e2f-c826-4ee5-b128-d3261f1d8eea',
      data: ''
    },
    {
      id: '63334021-19f3-4c0e-b506-5d5a348a1881',
      type: 'Text',
      name: 'mission_button_title_active',
      nameSpace: '',
      className: '',
      x: 48,
      y: 9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Quests',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#1e3763',
        strokeThickness: 4,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#1e3763',
        dropShadowDistance: 3,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 2,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '794bfcca-e61f-4b3d-b86a-05558c8b14eb',
      data: ''
    },
    {
      id: '94f048ba-48a0-4357-ba0c-8269d2424e43',
      type: 'Text',
      name: 'mission_button_title_timer',
      nameSpace: '',
      className: '',
      x: 53,
      y: -10,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Quests',
      localize: true,
      maxWidth: 180,
      maxHeight: 50,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#1e3763',
        strokeThickness: 4,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#1e3763',
        dropShadowDistance: 3,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 2,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '7539a2e0-c62e-425c-87e2-13a6c99f1805',
      data: ''
    },
    {
      id: '3b866541-0ed1-4733-bf56-cd2a232a475e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -45,
      y: 15,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'mission_timer_back',
      parent: '7539a2e0-c62e-425c-87e2-13a6c99f1805',
      data: ''
    },
    {
      id: '9c65ee41-4e3d-480a-adca-bbcb32f965a0',
      type: 'Text',
      name: 'mission_button_title_reward',
      nameSpace: '',
      className: '',
      x: 48,
      y: 9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'ClaimReward',
      localize: true,
      maxWidth: 199,
      maxHeight: 60,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#1e3763',
        strokeThickness: 4,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#1e3763',
        dropShadowDistance: 3,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 2,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '52caeeba-d355-408d-bcd8-829624648127',
      data: ''
    },
    {
      id: 'c47ef459-ada9-4fc5-9369-5729befd4cd1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 50,
      y: 48,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'UI_halloween_mission_notification_bar2',
      parent: '31adbf9e-5830-4b59-b53c-cb415d836ec6',
      data: ''
    },
    {
      id: '81a2856b-28cf-469b-9513-11c3b821a98e',
      type: 'NineSlicePlane',
      name: 'progress_bar_fill',
      nameSpace: '',
      className: '',
      x: 48,
      y: 48,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 200,
      height: 35,
      leftWidth: 16,
      topHeight: 16,
      rightWidth: 16,
      bottomHeight: 16,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'mission_bar_blue',
      parent: '31adbf9e-5830-4b59-b53c-cb415d836ec6',
      data: ''
    },
    {
      id: 'dcd0d00a-bcc4-4dd0-97e5-0a5c03232e86',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 50,
      y: 48,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'UI_halloween_mission_notification_bar',
      parent: '31adbf9e-5830-4b59-b53c-cb415d836ec6',
      data: ''
    },
    {
      id: 'e7951485-0083-4b51-81a7-1311ca7ab62b',
      type: 'Text',
      name: 'progress_bar_text',
      nameSpace: '',
      className: '',
      x: 130,
      y: 48,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '3/4',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 21,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#1e3763',
        strokeThickness: 4,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.3,
        dropShadowBlur: 0,
        dropShadowColor: '#8d3321',
        dropShadowDistance: 7,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 2,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '31adbf9e-5830-4b59-b53c-cb415d836ec6',
      data: ''
    },
    {
      id: '5cdcba53-ea3d-467b-956f-b0b41828f2d8',
      type: 'Text',
      name: 'progress_bar_title',
      nameSpace: '',
      className: '',
      x: 155,
      y: 32,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Harvest Crops',
      localize: false,
      maxWidth: 220,
      maxHeight: 30,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 25,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#FFFFFF',
        stroke: '#1e3763',
        strokeThickness: 4,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 225,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 2,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '31adbf9e-5830-4b59-b53c-cb415d836ec6',
      data: ''
    },
    {
      id: '4d0838ed-2dfa-4452-941b-864f7f07204c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8,
      y: -5,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'mission_timer_icon',
      parent: '3b866541-0ed1-4733-bf56-cd2a232a475e',
      data: ''
    },
    {
      id: '0d66c9ee-a80f-4e38-b2b9-506fa0b08124',
      type: 'Text',
      name: 'mission_button_text_timer',
      nameSpace: '',
      className: '',
      x: 55,
      y: 3,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '99:99:99',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 22,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: 'white',
        stroke: '#1e3763',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 3,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#8d3321',
        dropShadowDistance: 3,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '3b866541-0ed1-4733-bf56-cd2a232a475e',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class Xmas2022QuestsButtonLayout {
  static raw = raw;
  root: PIXI.Container
  mission_tray_container: PIXI.NineSlicePlane
  mission_progress_container: PIXI.Container
  progress_bar_fill: PIXI.NineSlicePlane
  progress_bar_text: PIXI.Text
  progress_bar_title: PIXI.Text
  mission_button_base_active: PIXI.Sprite
  mission_button_title_active: PIXI.Text
  mission_button_base_timer: PIXI.Sprite
  mission_button_title_timer: PIXI.Text
  mission_button_text_timer: PIXI.Text
  mission_button_base_reward: PIXI.Sprite
  mission_button_title_reward: PIXI.Text

  constructor() {
    populate(this, raw);
  }
}
